import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal, Dropdown, Menu} from 'antd'
import {QuestionCircleFilled, EditOutlined, DeleteOutlined, LockOutlined, UnlockOutlined, InfoCircleOutlined, EllipsisOutlined } from '@ant-design/icons'
import FormModalNext from './FormModalNext'
import FormModalTest from './FormModalTest'
import FormModalVersion from './FormModalVersion'
import CustomerMasterData from '../../customerMasterData'
import {withTranslation} from 'react-i18next'

const storage = window.localStorage
const {confirm} = Modal

@inject('mappingManagementStore')
@observer
class SearchResult extends Component {
  state = {
    nextModalVisible: false,
    modalVisibleTest: false,
    modalVisibleVersion: false,
    modalVisibleParameter: false,
  }

  componentDidMount() {
    const {mappingManagementStore} = this.props
    const {pageSize} = mappingManagementStore
    mappingManagementStore.onGetinboundCustomerAction()
    mappingManagementStore.onGetoutboundCustomerAction()
    mappingManagementStore.onChangePageNo()
    mappingManagementStore.onSearchAction({}, 1, pageSize)
  }

  handleEdit = (record) => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onDetailsAction(record.id).then(res => {
      this.setState({
        nextModalVisible: true,
      })
    })

  }
  handleCancelNext = () => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onChangeMappingDetails()
    mappingManagementStore.onChangePreFilter([])
    mappingManagementStore.onChangeFilter([])
    mappingManagementStore.onChangefieldDataSource([])
    this.setState({
      nextModalVisible: false
    })
  }
  handleActive = (record) => {
    const {mappingManagementStore} = this.props
    const activeStatus = record.statusCName === 'Normal'
    // mappingManagementStore.onChangePageNo()
    mappingManagementStore.onActiveAction(record.id, !activeStatus)
  }
  handleDel = (record) => {
    const {mappingManagementStore,t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        // mappingManagementStore.onChangePageNo()
        mappingManagementStore.onDeleteAction(record.id)
      },
      onCancel() {
        console.log('Cancel')
      },
    })
    return false
  }

  handleVersion = (record) => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onSearchVersionAction(record.id, 'MAPPING')
    this.setState({
      modalVisibleVersion: true,
      record: record
    })
  }
  handleCancelVersion = () => {
    this.setState({
      modalVisibleVersion: false
    })
  }
  handleTest = (record) => {
    this.setState({
      modalVisibleTest: true,
      record: record
    })
  }
  handleCancelTest = () => {
    this.setState({
      modalVisibleTest: false
    })
  }
  handleParameter = (record) => {
    this.setState({
      modalVisibleParameter: true,
      record: record
    })
  }
  handleCancelParameter = () => {
    this.setState({
      modalVisibleParameter: false
    })
  }
  handlePageChange = (page, pageSize) => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {mappingManagementStore, t} = this.props
    const {pageNo, pageSize, itemCount, mappingList} = mappingManagementStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(mappingList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName}
               scroll={{x: '100%', scrollToFirstRowOnChange: true}}>
          {/*<Table.Column width={80} align='center' title='ID' dataIndex="id" key="id" render={(text, record, index) => `${(pageNo-1)*pageSize+(index + 1)}`} />*/}
          <Table.Column align="center" width={80} fixed="left" title={t(`mappingManagement.status`)} dataIndex="statusCName" key="statusCName"
                        render={(text) => <div style={{
                          display: 'inline-block',
                          height: 24,
                          width: 24,
                          lineHeight: '24px',
                          fontSize: 12,
                          borderRadius: 24,
                          color: 'white',
                          textAlign: 'center',
                          background: text === 'Normal' ? themeStyle?.statusColor?.split(',')?.[0] || '#97cf7c' : text === 'Abnormal' ? themeStyle?.statusColor?.split(',')?.[1] || '#ef6e6e' : '#7ac3e0'
                        }} title={text}>{text?.charAt(0)}</div>}
          />
          <Table.Column width={250} fixed="left" title={t(`mappingManagement.mappingName`)} dataIndex="name" key="name" ellipsis={true}/>
          <Table.Column width={150} title={t(`mappingManagement.mappingType`)} dataIndex="mappingTypeAlias" key="mappingTypeAlias" ellipsis={true}/>
          <Table.Column width={150} title={t(`mappingManagement.attribute`)} dataIndex="mappingAttributeAlias" key="mappingAttributeAlias"
                        ellipsis={true}/>
          <Table.Column width={180} title={t(`mappingManagement.inboundCustomer`)} dataIndex="inboundConfigInfo" key="inboundConfigInfo"
                        ellipsis={true}
                        render={(text, record) => text?.customerStr}/>
          <Table.Column width={250} title={t(`mappingManagement.inboundName`)} dataIndex="inboundConfigInfo" key="inboundConfigInfo" ellipsis={true}
                        render={(text, record) => text?.apiName}/>
          <Table.Column width={180} title={t(`mappingManagement.outboundCustomer`)} dataIndex="outboundConfigInfo" key="outboundConfigInfo"
                        ellipsis={true}
                        render={(text, record) => text?.customerStr}/>
          <Table.Column width={250} title={t(`mappingManagement.outboundName`)} dataIndex="outboundConfigInfo" key="outboundConfigInfo"
                        ellipsis={true}
                        render={(text, record) => text?.apiName}/>
          <Table.Column fixed="right" width={140} align="center" title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleActive(record)} className={record.statusCName === 'Normal' ? null : 'grey'}
                      icon={record.statusCName === 'Normal' ? <UnlockOutlined/> : <LockOutlined/>}
                      title={record.statusCName === 'Normal' ? t(`general.active`) : t(`general.inactive`)}/>
              <Button type="link" onClick={() => this.handleVersion(record)} icon={<InfoCircleOutlined/>} title={t(`general.version`)}/>
              <Dropdown overlay={<Menu items={
                record?.mappingAttributeAlias !== 'OnlyCopy' ? [
                  {label: t(`general.edit`), key: 'edit',icon: <EditOutlined />, onClick: ()=>this.handleEdit(record)},
                  {label: t(`general.delete`), key: 'delete', icon: <DeleteOutlined />, onClick: ()=>this.handleDel(record)}
                ]: [
                  {label: t(`general.delete`), key: 'delete', icon: <DeleteOutlined />, onClick: ()=>this.handleDel(record)}
                ]
              }/>}>
                <Button type='link' icon={<EllipsisOutlined />}  />
              </Dropdown>
            </>
          )}/>
        </Table>
        {this.state.nextModalVisible ? <FormModalNext
          nextModalVisible={this.state.nextModalVisible}
          handleCancelNext={this.handleCancelNext}
          title="edit"
        /> : null}
        {this.state.modalVisibleTest ? <FormModalTest
          addModalVisible={this.state.modalVisibleTest}
          handleCancel={this.handleCancelTest}
          record={this.state.record}
        /> : null}
        {this.state.modalVisibleVersion ? <FormModalVersion
          title="MAPPING"
          addModalVisible={this.state.modalVisibleVersion}
          handleCancel={this.handleCancelVersion}
          record={this.state.record}
        /> : null}
        {this.state.modalVisibleParameter ?
          <Modal
            title={[<p style={{marginBottom: 0}}>{t(`mappingManagement.mappingName`)}: <span
              style={{fontWeight: 'normal'}}>{this.state.record.name}</span></p>]}
            // closable={false}
            onCancel={this.handleCancelParameter}
            visible={this.state.modalVisibleParameter}
            maskClosable={false}
            destroyOnClose={true}
            width="80%"
            centered
            footer={null}
          >
            <CustomerMasterData dataType="parameter" id={this.state.record.id}/>
          </Modal> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
